import { useUserNotification } from 'hooks/useUserNotification';
import type { IntlKey } from 'locales';
import { FC, PropsWithChildren, useCallback } from 'react';

export interface WithCopyProps {
  content?: string;
  toastSuccessMessage?: IntlKey;
  toastErrorMessage?: IntlKey;
}

export const WithCopy: FC<PropsWithChildren<WithCopyProps>> = props => {
  const notification = useUserNotification();
  const onCopyMessage = useCallback(
    (content: any): void => {
      navigator.clipboard.writeText(content).then(
        () => {
          notification.success({
            title: { id: 'toast.copyToClipboard' },
            content: [{ id: props.toastSuccessMessage ?? 'messageCopied' }],
          });
        },
        () => {
          notification.error({
            title: { id: 'toast.copyToClipboard' },
            content: [{ id: props.toastErrorMessage ?? 'messageCopyingError' }],
          });
        },
      );
    },
    [notification, props.toastSuccessMessage, props.toastErrorMessage],
  );

  return <div onClick={() => onCopyMessage(props.content)}>{props.children}</div>;
};
